import $ from '../$';
import removeData from '../functions/removeData';
$.removeData = removeData;
